import React from 'react'
import './Header.css'
import Searchbar from './Searchbar.js';
import { Link, useLocation } from 'react-router-dom';
import Sortbar from './Sortbar.js';
import Reviewbutton from './Reviewbutton.js';

function Header() {
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    
    return (
        <div className='header'>
            <Link to='/' className='logo-container'>
                <div className='logo-text'>
                    <div className='h2'>
                        Wait Times <span className='clock-o'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                                <path d="M10 5V10L13 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                <circle cx="10" cy="10" r="1" fill="currentColor"/>
                            </svg>
                        </span>ntario
                    </div>
                    <div className='h3'>Diagnostic Imaging</div>
                </div>
            </Link>
            {isHomePage && <Searchbar />}
            {isHomePage && <Sortbar />}
            <Reviewbutton />
        </div>
    );
}

export default Header